const SEO = [
	{
		page: "home",
		description:
			"Aluno da FATEC apaixonado por front-end desde o terceiro semestre do curso, aprendendo sobre Javascript e Typescript",
		keywords: ["Nicolas", "Nicolas L", "Nicolas Lemuel"],
	},

	{
		page: "about",
		description:
			"Aluno da FATEC apaixonado por front-end desde o terceiro semestre do curso, aprendendo sobre Javascript e Typescript",
		keywords: ["Nicolas", "Nicolas L", "Nicolas Lemuel"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Nicolas", "Nicolas L", "Nicolas Lemuel"],
	},

	{
		page: "projects",
		description:
			"Pequenos projetos realizados com o intuito de aplicar os conceitos aprendidos.",
		keywords: ["Nicolas", "Nicolas L", "Nicolas Lemuel"],
	},

	{
		page: "contact",
		description:
			"Obrigado pelo seu interesse em entrar em contato comigo. Agradeço seus comentários, perguntas e sugestões.",
		keywords: ["Nicolas", "Nicolas L", "Nicolas Lemuel"],
	},
];

export default SEO;
